import React from 'react';
import { Formik, Form, Field, FieldArray } from 'formik';
import * as Yup from 'yup';
import { Grid, Box, Button, Divider } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { agentchangePasswordDispatch } from '../../reducers/UserReducer';

const logInSchema = Yup.object().shape({
	oldpassword: Yup.string().required('current password is required'),
	newpassword: Yup.string()
		.required('Password is required')
		.min(4, 'Password is too short - should be 4 chars minimum'),
	confirmpassword: Yup.string()
		.required('Confirmpassword is required')
		.min(4, 'Confirmpassword is too short - should be 4 chars minimum'),
});

const ChangePasswordForm = () => {
	const dispatch = useDispatch();
	const { agentlogin } = useSelector((state) => state.user);
	const handleFormSubmit = (data) => {
		let formData = {
			userEmail:
				agentlogin &&
				agentlogin.result &&
				agentlogin.result.result &&
				agentlogin.result.result.email,
			confirmpassword: data.confirmpassword,
			newpassword: data.newpassword,
			oldpassword: data.oldpassword,
		};
		// console.log('data', formData);

		dispatch(agentchangePasswordDispatch(formData));
	};
	return (
		<Formik
			initialValues={{
				oldpassword: '',
				newpassword: '',
				confirmpassword: '',
			}}
			validationSchema={logInSchema}
			onSubmit={handleFormSubmit}>
			{(formik) => {
				const { errors, setFieldValue } = formik;
				return (
					<Form>
						<Box style={{ padding: 10 }}>
							<Grid container style={{ marginTop: 5, padding: 10 }} spacing={4}>
								<Grid item xs={12} lg={6}>
									<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
										Current Password
									</span>
									<br></br>
									<Field
										name='oldpassword'
										type='password'
										placeHolder='Enter Current Password'
										style={{
											padding: 10,
											width: '100%',
											borderRadius: 5,
											border: errors?.oldpassword
												? '2px solid red'
												: '1px solid',
											marginTop: 10,
										}}
										inputProps={{
											style: { padding: 12 },
										}}
									/>
									<br />
									{errors?.oldpassword ? (
										<span style={{ color: 'red', fontSize: 12 }}>
											{errors?.oldpassword}
										</span>
									) : null}
								</Grid>
								<Grid item xs={12} lg={6}>
									<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
										New Password
									</span>
									<br></br>
									<Field
										name='newpassword'
										type='password'
										placeHolder='Enter New Password'
										style={{
											padding: 10,
											width: '100%',
											borderRadius: 5,
											border: errors?.newpassword
												? '2px solid red'
												: '1px solid',
											marginTop: 10,
										}}
										inputProps={{
											style: { padding: 12 },
										}}
									/>
									<br />
									{errors?.newpassword ? (
										<span style={{ color: 'red', fontSize: 12 }}>
											{errors?.newpassword}
										</span>
									) : null}
								</Grid>
								<Grid item xs={12} lg={6}>
									<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
										Confirm New Password
									</span>
									<br></br>
									<Field
										name='confirmpassword'
										type='password'
										placeHolder='Enter Confirm New Password'
										style={{
											padding: 10,
											width: '100%',
											borderRadius: 5,
											border: errors?.confirmpassword
												? '2px solid red'
												: '1px solid',
											marginTop: 10,
										}}
										inputProps={{
											style: { padding: 12 },
										}}
									/>
									<br />
									{errors?.confirmpassword ? (
										<span style={{ color: 'red', fontSize: 12 }}>
											{errors?.confirmpassword}
										</span>
									) : null}
								</Grid>
								<Grid item xs={12} lg={6}></Grid>
								<Grid item xs={12} lg={3}>
									<Button
										type='submit'
										style={{
											background: 'rgb(25, 118, 210)',
											color: 'white',
											marginTop: 30,
											// padding: 16,
											borderRadius: 5,
											width: '100%',
										}}>
										Save
									</Button>
								</Grid>
							</Grid>
						</Box>
					</Form>
				);
			}}
		</Formik>
	);
};

export default ChangePasswordForm;
